<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <span>{{ chipValue(params.value) }}</span>
    </vs-chip>
</template>

<script>
export default {
  name: 'CellRendererStatus',
  computed: {
    chipColor () {
      return (value) => {
        if (parseInt(value) === 0) return 'danger'
        else if (parseInt(value) === 1) return 'success'
        else if (parseInt(value) === 'deactivated') return 'warning'
        else return 'primary'
      }
    },
    chipValue () {
      return (value) => {
        console.log('value 2 ', value)
        if (parseInt(value) === 0) return 'Unpaid'
        else if (parseInt(value) === 1) return 'Paid'
        else if (parseInt(value) === 'deactivated') return 'warning'
        else return 'primary'
      }
    }
  }
}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
